import { createFileRoute } from "@tanstack/react-router";
import { CChartEventCollectionView } from "src/components/views/spc/cChartEvents/CChartEventCollectionView.tsx";
import { CChartEventCollectionApi } from "src/api/generated/spc/cChartEvents/cChartEventCollectionApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute(
	"/_authenticated/_shell/spc/collectCChartEvents/controlChartGroup/$controlChartGroupId",
)({
	staticData: {
		legacyViewKey: "cChartEventCollectionPages",
		listGeneratedViews: async () =>
			(await CChartEventCollectionApi.getUserEventCollectionChartGroups()).map((chartGroup) => ({
				id: chartGroup.chartGroupId,
				title: chartGroup.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <CChartEventCollectionView controlChartGroupId={id} isActive={isActive} />;
}
